/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationReference } from './HomeHealthCertificationReference';
import {
    HomeHealthCertificationReferenceFromJSON,
    HomeHealthCertificationReferenceFromJSONTyped,
    HomeHealthCertificationReferenceToJSON,
    HomeHealthCertificationReferenceToJSONTyped,
} from './HomeHealthCertificationReference';

/**
 * 
 * @export
 * @interface HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner
 */
export interface HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    credentials: string;
    /**
     * 
     */
    npi: string;
    /**
     * 
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     */
    ref: Array<HomeHealthCertificationReference>;
}



/**
 * Check if a given object implements the HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner interface.
 */
export function instanceOfHomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner(value: object): value is HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('credentials' in value) || value['credentials'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('ref' in value) || value['ref'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerFromJSON(json: any): HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner {
    return HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerFromJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'credentials': json['credentials'],
        'npi': json['npi'],
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'ref': ((json['ref'] as Array<any>).map(HomeHealthCertificationReferenceFromJSON)),
    };
}

export function HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerToJSON(json: any): HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner {
    return HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerToJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerToJSONTyped(value?: HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'credentials': value['credentials'],
        'npi': value['npi'],
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'ref': ((value['ref'] as Array<any>).map(HomeHealthCertificationReferenceToJSON)),
    };
}

